module.exports = "button.btn {\n  margin-right: 24px; }\n\ntable {\n  align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/confirmation-page-success/confirmation-page-success.component.scss
// module id = ./src/app/shared-components/confirmation-page-success/confirmation-page-success.component.scss
// module chunks = main